import React from "react";
import ErrorBoundary from "./ErrorBoundary";
import ReactSwipe from "react-swipe";

const DataCarousel = ({ data_rows = [] }) => {
  const rowCount = data_rows.length
  let reactSwipeEl;

  const dataElement = (data, idx) => (
    <div key={`${data.client_settings_id}-${idx}`} className="font-medium text-sm text-gray-700 whitespace-normal">
      <div>
        Product Name:
        <span className="text-sm font-small text-gray-900"> { data["product_name"] }</span>
      </div>
      <div>
        Product ID Repeats:
        <span className="text-sm font-small text-gray-900"> { data["product_id_repeats"] }</span>
      </div>
      <div>
        Category:
        <span className="text-sm font-small text-gray-900"> { data["category"] }</span>
      </div>
      <div>
        GTIN Repeats:
        <span className="text-sm font-small text-gray-900"> { data["gtin_repeats"] }</span>
      </div>
      <div>
        Sub Category:
        <span className="text-sm font-small text-gray-900"> { data["sub_category"] }</span>
      </div>
      <div>
        Best Search Rank:
        <span className="text-sm font-small text-gray-900"> { data["best_search_rank"] }</span>
      </div>
      <div>
        Brand:
        <span className="text-sm font-small text-gray-900"> { data["brand"] }</span>
      </div>
      <div>
        Count of Searches (7 Day):
        <span className="text-sm font-small text-gray-900"> { data["count_of_searches_7_day"] }</span>
      </div>
      <div>
        Looked in Graph:
        <span className="text-sm font-small text-gray-900"> { data["is_from_graph"] ? "yes" : "no" }</span>
      </div>
      <div>
        Last Gathered Date:
        <span className="text-sm font-small text-gray-900"> { data["last_gathered_date"] }</span>
      </div>
      <div>
        Source of Product:
        <span className="text-sm font-small text-gray-900"> { data["source_of_product"] }</span>
      </div>
      <div>
        Last Found in Search Date:
        <span className="text-sm font-small text-gray-900"> { data["last_found_in_search_date"] }</span>
      </div>
      <div>
        Last Change to Product:
        <span className="text-sm font-small text-gray-900"> { data["last_change_to_product"] }</span>
      </div>
    </div>
  );

  return (
    <ErrorBoundary>
      <div>
        <ReactSwipe
          className="carousel"
          swipeOptions={{ continuous: false }}
          ref={el => (reactSwipeEl = el)}
        >
          {data_rows.map((val, idx) => dataElement(val, idx))}
        </ReactSwipe>
        { rowCount > 1 &&
          <>
            <button onClick={() => reactSwipeEl.prev()} className="mr-5 inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Previous</button>
            <button onClick={() => reactSwipeEl.next()} className="inline-flex items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Next</button>
          </>
        }
      </div>
    </ErrorBoundary>
  );
}

export default DataCarousel;
